import React from 'react';
import { Trans } from 'react-i18next';

import { Badge } from '@shared/ui/components/Badge';

import { StatusBadgeProps, StatusBadgeVariantMappingType } from './RegistrationsList.types';
import { statusLabels } from './statusLabels';

export function StatusBadge({ registration }: StatusBadgeProps) {
  const statusColors: StatusBadgeVariantMappingType = {
    created: 'secondary',
    crewQuantityRequested: 'warning',
    crewQuantityWaitingForApproval: 'warning',
    approved: 'success',
  };

  if (!registration.status) {
    return null;
  }

  return <Badge variant={statusColors[registration.status.name]}>{statusLabels[registration.status.name]}</Badge>;
}
